<kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em;">
      <span class="k-icon k-font-icon k-i-form-element"></span>{{this.dialogNameTranslated()}}
    </div>
</kendo-dialog-titlebar>
<kendo-textbox [(value)]="this.title" [maxlength]="this.maxLength"></kendo-textbox>
<kendo-dialog-actions>
    <button kendoButton (click)="onCancelAction()">{{'Cancel' | translate: 'Cancel'}}</button>
    <button
      kendoButton
      (click)="onConfirmAction()"
      themeColor="primary">
      {{'Ok' | translate: 'Ok'}}
    </button>
  </kendo-dialog-actions>
